import BaseModel from './BaseModel';
import CalendarEventTimeActivityCollection from '../collections/CalendarEventTimeActivityCollection';

export default class CalendarEvent extends BaseModel
{

    init(data)
    {
        super.init(data);
        
        this.html_id = 'calendar-event-' + data.id;
        this.time_activities = new CalendarEventTimeActivityCollection(
            data.time_activities || [], data.id
        );
    }

    static getPrefix()
    {
        return 'planning:calendar-event';
    }

    static getEndpoint()
    {
        return window.Planning.endpoints.calendarEvent;
    }

    requestData()
    {
        return {
            user_id: this.user_id,
            title: this.title,
            address: this.address,
            linked_to: this.linked_to,
            starts_at: this.getStartsAt().format('YYYY-MM-DD HH:mm:ss'),
            ends_at: this.getStartsAt().format('YYYY-MM-DD HH:mm:ss'),
            notes: this.notes,
            timetracking_allowed: this.timetracking_allowed,
            event_type: this.event_type,
            accounted_for_weekly_hours: this.accounted_for_weekly_hours,
        }
    }

    getDay()
    {
        return this.getStartsAt().format('YYYY-MM-DD');
    }

    getStartsAt()
    {
        return window.moment(this.starts_at);
    }

    getStartsAtTime()
    {
        return this.getStartsAt().format('HH:mm');
    }

    setStartsAtTime(time)
    {
        this.starts_at = window.moment(this.getStartsAt().format('YYYY-MM-DD') + ' ' + time + ':00').format('YYYY-MM-DD HH:mm:ss');
    }

    getEndsAt()
    {
        return window.moment(this.ends_at);
    }

    getEndsAtTime()
    {
        if ( ! this.ends_at ) {
            return null;
        }
        
        return this.getEndsAt().format('HH:mm');
    }

    setEndsAtTime(time)
    {
        this.ends_at = window.moment(this.getEndsAt().format('YYYY-MM-DD') + ' ' + time + ':00').format('YYYY-MM-DD HH:mm:ss');
    }

    getTimeDifference(format = 'H:mm:ss')
    {
        return window.moment().startOf('day').seconds(this.getTimeDifferenceInSeconds()).format(format);
    }

    getTimeDifferenceInSeconds()
    {
        return this.getTimeDifferenceIn('seconds');
    }

    getTimeDifferenceInHours()
    {
        return this.getTimeDifferenceIn('hours');
    }

    getTimeDifferenceIn(attribute = 'hours')
    {
        if ( ! this.starts_at ) {
            return 0;
        }

        return this.getEndsAt().diff(this.getStartsAt(), attribute, true);
    }

    toCalendarEvent()
    {
        return {
            extendedProps: {
                model: this,
                user: this.getUser(),
                worksite: this.getWorksite(),
            },
            id: this.id,
            title: this.title,
            start: this.starts_at,
            end: this.ends_at,
            className: 'calendar-event calendar-event--' + this.event_type,
            backgroundColor: '#FFF',
            textColor: '#3D3D3D'
        }
    }

}